export * from "./property-card";
export * from "./property-item-header";
export * from "./property-item-row";
export * from "./property-skeleton";
export * from "./empty-property-card";
export * from "./error-card";

import { EmptyPropertyCardComponent } from "./empty-property-card";
import { ErrorCardComponent } from "./error-card";
import { PropertyCardComponent } from "./property-card";
import { PropertyItemHeaderComponent } from "./property-item-header";
import { PropertyItemRowComponent } from "./property-item-row";
import { PropertySkeletonComponent } from "./property-skeleton";

export const propertyLayoutAtoms = [
  PropertyCardComponent,
  PropertyItemHeaderComponent,
  PropertyItemRowComponent,
  PropertySkeletonComponent,
  EmptyPropertyCardComponent,
  ErrorCardComponent
];
